import React from 'react';
import { Tooltip } from '../../../../ui-toolkit';
import { ColumnDef, createColumnHelper } from '@tanstack/react-table';
import { TextButtonTW } from '../../../../tailwindComponents/buttonTW/TextButtonTW';
import { formatPhoneNumber } from '../../../../utilities/shared/formatPhoneNumber';
import { DataTableTW } from '../../../../tailwindComponents/tableTW/DataTableTW';
import { BodyTextTW } from '../../../../tailwindComponents/bodyText/BodyTextTW';
import { copyAddressToClipboard } from '../../../../utilities/order/header/copyAddressToClipboard';
import { ePartyType } from '../../../../ui-toolkit/enums/ePartyType';
import { DisplayPartyPurpose, ePartyPurpose } from '../../../../ui-toolkit/enums/ePartyPurpose';
import { IPropertyAddress, propertyAddressToString } from '../../../../ui-toolkit/orders/interfaces/IPropertyAddress';
import { IParty } from '../../../../ui-toolkit/orders/interfaces/IParty';

const columnHelper = createColumnHelper<IParty>();
const columns: ColumnDef<IParty, any>[] = [
  columnHelper.accessor(
    (row: IParty) => {
      if (row.type === ePartyType.entity) return row.entity_name;
      return `${row.first_name} ${row.last_name}`;
    },
    { id: 'Name', sortingFn: 'text', header: 'Name' }
  ),
  columnHelper.accessor('email', {
    cell: (info) => {
      const email = info.getValue<string | undefined>();
      if (!email) return '-';
      return (
        <TextButtonTW>
          <a href={`mailto:${email}`}>{email}</a>
        </TextButtonTW>
      );
    },
    header: 'Email',
  }),
  columnHelper.accessor('purpose', {
    cell: (info) => DisplayPartyPurpose[info.getValue<ePartyPurpose>()],
    header: 'Function',
  }),
  columnHelper.accessor('phone_number', {
    cell: (info) => formatPhoneNumber(info.getValue<string | undefined>() ?? '') ?? '-',
    header: 'Phone',
    enableSorting: false,
  }),
  columnHelper.accessor('address', {
    cell: (info) => {
      const addr = info.getValue<IPropertyAddress | undefined>();
      if (addr === undefined || !addr.street_address) return '-';
      return (
        <Tooltip
          trigger={'hover'}
          placement={'top'}
          tooltipContent={<BodyTextTW>{propertyAddressToString(addr)}</BodyTextTW>}
        >
          <div className={'cursor-pointer'} onClick={() => copyAddressToClipboard(addr)}>
            {addr.street_address}
          </div>
        </Tooltip>
      );
    },
    header: 'Address',
    enableSorting: false,
  }),
];

export const PartyContactsTable: React.FC<{ selectedParties: IParty[] }> = ({ selectedParties }) => {
  return <DataTableTW columns={columns} data={selectedParties} isSorted />;
};
